import BaseQuestionModel from '../BaseQuestionModel'
import { IQuestionModelConstructor, IQuestionSchema, QuestionType } from '../types'

const VoidQuestionModel: IQuestionModelConstructor = (_questionSchema, action) => {
  const VoidQuestionSchema: IQuestionSchema = {
    id: '?',
    text: '',
    type: QuestionType.VOID,
    position: 0,
    time: 0
  }
  const { model } = BaseQuestionModel({
    questionType: QuestionType.VOID,
    questionSchema: VoidQuestionSchema,
    action,
    submitResponse: (): unknown => null
  })
  return model
}
export default VoidQuestionModel
